module.exports = __webpack_public_path__ + "media/Manitou.comV4.8a3b4533.mp4";